import * as Sentry from "@sentry/react";
import React from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router";

import { DjangoSentryConfig } from "./types/props-schema";

/**
 * Starts up Sentry based on values written into the HTML via our sentry_config
 * template tag.
 */
export function initSentry() {
  const sentryConfigEl = document.getElementById("sentry-config");

  if (!sentryConfigEl) {
    console.warn(
      "#sentry-config element not found on the page. Cannot initialize Sentry."
    );

    return;
  }

  const sentryConfig: DjangoSentryConfig = JSON.parse(sentryConfigEl.innerText);

  if (sentryConfig.dsn === null) {
    // eslint-disable-next-line no-console
    console.info("No SENTRY_DSN set. Not starting Sentry.");
    return;
  }

  Sentry.init({
    dsn: sentryConfig.dsn,
    release: sentryConfig.release,
    environment: sentryConfig.environment,
    tracesSampleRate: sentryConfig.traces_sample_rate,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
  });
}
